import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. Meta Pixel Tracking
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "PageView");
    }

    // 2. Google Tag Manager Data Layer Push
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pageview",
        pagePath: pathname
      });
    }

    // 3. Google Analytics (gtag) explicit page_view
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "page_view", {
        page_path: pathname
      });
    }
  }, [pathname]);

  return null;
}
